import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class wageService {

  constructor(private api : ApiService) { }


getComponents(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/component/getComponents?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

addOrUpdateComponent(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/component/addOrUpdateComponent')
  return this.api.post(url,formData);
}
getCustomer(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/account/getCustomer?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
getWarehouseList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/warehouse/getWarehouse?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

getDesignation(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/employee/getDesignation?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

getCategory(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/employee/getCategory?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

getShift(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/employee/getShift?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}



getStructure(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/structure/getStructure?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
addOrUpdateStructure(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/structure/addOrUpdateStructure')
  return this.api.post(url,formData);
}
getAssociateComponent(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/structure/getAssociateComponent?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

getVendor(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/vendor/getVendorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}


addOrUpdateAssociateComponent(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/structure/addOrUpdateAssociateComponent`;
  return this.api.post(url,formData);
}


wageCalculation(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/wage-calculation/calculate`;
  return this.api.post(url,formData);
}

getLineItems(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/structure/getLineItems?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 
getEmployeeAttendance(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/attendance/getEmployeeAttendance?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

syncAttendance(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/attendance/sync`;
  return this.api.post(url,formData);
}

modifyAttendance(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/attendance/modifyAttendance`;
  return this.api.post(url,formData);
} 

approveAttendance(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/attendance/approveAttendance`;
  return this.api.post(url,formData);
} 
revertAttendance(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/attendance/revert-approval`;
  return this.api.post(url,formData);
} 

evaluateAttendance(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-rule-service/rule-engine/evaluate-attendance`;
  return this.api.post(url,formData);
}

getRuleEngineJobStatus(jobId:any){
  const url = `${environment.New_BASE_DOMAIN}lms-rule-service/rule-engine/job-status/${jobId}`;
  return this.api.get(url);
}


getMappingInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/account/getMappingInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

calculateBulkPayroll(
  warehouseId: number,
  customerId: number,
  month: number,
  year: number,
  jobName: string,
  employeeFilters?: { vendorId?: any; designationId?: any; skillGroupId?: any }
) {
  let url = `${environment.New_BASE_DOMAIN}lms-service/wage-calculation/calculate-bulk` +
    `?warehouseId=${warehouseId}` +
    `&customerId=${customerId}` +
    `&month=${month}` +
    `&year=${year}` +
    `&jobName=${encodeURIComponent(jobName)}`;

  if (employeeFilters) {
    ['vendorId', 'designationId', 'skillGroupId'].forEach((key) => {
      const value = employeeFilters[key as keyof typeof employeeFilters];
      if (value !== null && value !== undefined && value !== '') {
        url += `&${key}=${encodeURIComponent(value)}`;
      }
    });
  }

  return this.api.post(url, {});
}

getOrganization(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/account/getOrganization?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}  

getWageTransactions(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/wage-transaction/getWageTransactions?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
} 

recalculate(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/wage-calculation/recalculate`;
  return this.api.post(url,formData);
} 
bulkStatus(referenceId:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/wage-calculation/bulk-status/${referenceId}`;
  return this.api.get(url);
} 

}
